
import Vue from 'vue';

export default Vue.extend({
  props: {
    width: { type: Number, default: 24 },
    height: { type: Number, default: 24 },
  },
});
